export const SalesControllerFactory = ({
  salesService,
}: {
  salesService: ISalesService;
}) => {
  const addSalesAck: IAddSalesAck = async ({
    clinicId,
    requestedFor,
    message,
  }) => {
    const response = await salesService.addSalesAckService({
      clinic_id: clinicId,
      requested_for: requestedFor,
      message: message,
    });

    return response;
  };

  return {
    addSalesAck,
  };
};
